import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Postdata } from '../../helpers/api.service';
import HttpService from '../../helpers/httpServices';
import { message } from '../../redux/actions/toastActions';
import { Topbar } from '../../components/include/Topbar';
import HiOutlineDotsVertical from "../../assets/Icons/HiOutlineDotsVertical.svg";
import DeleteModal from '../../components/common/DeleteModal';
import { isPermission, isRole } from '../../redux/selectors/authSelector';
import Error403Page from '../ErrorPage';


const View_facilities = () => {
    const [data, setData] = useState({});
    const [openMenuIndex, setOpenMenuIndex] = useState(false);
    const [loader, setLoader] = useState(false);
    const menuRefs = useRef({});
    const navigate = useNavigate();
    const [selectedImage, setSelectedImage] = useState('');
    const dispatch = useDispatch();
    const params = useParams();
    const [selectedId, setSelectedId] = useState(null);
    const [modalOpenDelete, setmodalOpenDelete] = useState(false);
    const permissions = useSelector(isPermission);
    const role = useSelector(isRole)
    console.log("permissions", permissions)
    const isAccessible = role == "schooladmin" || permissions && permissions?.includes('view_Education') || false;
    const addPermission = role == "schooladmin" || permissions && permissions?.includes('edit_Education') || false;
    const deletePermission = role == "schooladmin" || permissions && permissions?.includes('delete_Education') || false;




    const toggleMenu = (index) => {
        setOpenMenuIndex(!openMenuIndex);
        // setOpenMenuIndex(true);
    };
    const handleDelete = (id) => {
        setLoader(true)
        Postdata(HttpService.facility_delete, { id: id }).then((res) => {
            if (res.status === 200) {
                navigate('/education');
            }
            else {
                dispatch(message(res.message));
            }
        });
        setLoader(false)
    }

    const fetchData = () => {
        setLoader(true);
        Postdata(HttpService.facility_show, { id: params.id }).then((res) => {
            if (res.status === 200) {
                setData(res.data);
                if (res.data.image && res.data.image.length > 0) {
                    setSelectedImage(res.data.image[0]); // Set first image initially
                }
            }else{

                dispatch(message(res.message));
            }
        });
        setLoader(false)
    }

    useEffect(() => {
        fetchData();
    }, [])
    if (loader) {
        return <div>Loading....</div>
    }
    if(!isAccessible){
    return <Error403Page/>
    } 
    return (
        <>
            <Topbar aerrow={true} />
            <div className=" mx-auto p-4">
                {selectedImage && (
                    <div className="mb-4">
                        <img
                            src={selectedImage}
                            alt="Selected"
                            className="w-full h-96 object-fill rounded-lg shadow"
                        />
                    </div>
                )}
                <div className="flex overflow-x-auto space-x-2 mb-4">
                    {data.image &&
                        data.image.map((img, idx) => (
                            <img
                                key={idx}
                                src={img}
                                alt={`Thumbnail ${idx}`}
                                onClick={() => setSelectedImage(img)}
                                className={`h-24 w-24 object-cover rounded cursor-pointer border-2 ${selectedImage === img ? 'border-blue-500' : 'border-transparent'
                                    }`}
                            />
                        ))}
                </div>
                <div className="bg-white rounded-xl p-4 relative flex justify-between text-gray-800   mx-auto">
                    <div>
                        <h3 className="text-md font-semibold mb-2">
                            {data.name}
                        </h3>
                        <h3 className="text-sm font-semibold mb-2">
                            Purpose : <span className='text-sm font-normal'>{data.purpose}</span>
                        </h3>
                        <h3 className="text-sm font-normal mb-2">
                            {data.description}
                        </h3>


                    </div>
                    {(addPermission|| deletePermission) &&<div className='bg-white  '>
                        <div className="absolute top-3 right-3">
                            <button onClick={() => toggleMenu()}>
                                <img
                                    src={HiOutlineDotsVertical}
                                    className="text-black-500 hover:text-black"
                                />
                            </button>

                            {openMenuIndex && (
                                <div ref={(el) => (menuRefs.current = el)} className="absolute right-0 w-20 bg-white shadow-md border rounded-xl z-10">
                                  {addPermission &&  <button
                                        className="block w-full text-left px-3 rounded-b-xl py-2 text-sm hover:bg-gray-100"
                                        onClick={() => navigate(`/education/facilities/edit/${data._id}`, { state: { type: "edit" } })}
                                    >
                                        Edit
                                    </button>}
                                   {deletePermission && <button
                                        onClick={() => {
                                            setSelectedId(data._id);
                                            setmodalOpenDelete(true);
                                        }}
                                        className="block w-full text-left px-3 rounded-b-xl py-2 text-sm hover:bg-gray-100"
                                    >
                                        Delete
                                    </button>}
                                </div>
                            )}
                        </div>

                    </div>}
                </div>
                <DeleteModal
                    title="Delete Facility"
                    message="Are you sure you want to delete Facility?
It will erase all the data permanently."
                    modalOpenDelete={modalOpenDelete}
                    setmodalOpenDelete={setmodalOpenDelete}
                    handleDelete={handleDelete} // Don't call it here
                    selectedId={selectedId}
                    setSelectedId={setSelectedId}
                />

            </div>

        </>
    )
}

export default View_facilities